<template>
    <ol>
        <li v-for="answer in question.answer"
            :key="answer.key">
            <span class="sub-title">
                {{ answer.name }}
            </span>
            <VerticalAnalysis
                :question="answer"
                :contain="contain || ''"
                @set-patient="setPatient">
            </VerticalAnalysis>
        </li>
    </ol>
</template>

<script>
import OutcomeAnalysis from '.'
import VerticalAnalysis from './Vertical'

export default {
    name: 'multi-analysis',
    extends: OutcomeAnalysis,

    props: {
        contain: {
            type: String,
            required: false
        }
    },


    methods: {
        setPatient(patientList) {
            this.$emit('')
        }
    },

    components: {
        VerticalAnalysis
    }
}
</script>

<style lang="scss" scoped>
li {
    list-style-type: lower-alpha;
}
.sub-title {
    display: block;
    padding: 5px;
    font-size: 18px;
}
</style>